// eslint-disable-next-line import/prefer-default-export
export enum VERSIONS {
	VERSIONS_LOAD_START = 'VERSIONS_LOAD_START',
	VERSIONS_LOAD_DONE = 'VERSIONS_LOAD_DONE',
	VERSIONS_LOAD_FAIL = 'VERSIONS_LOAD_FAIL'
}

export enum IFRAME_VERSIONS {
	IFRAME_VERSIONS_LOAD_START = 'IFRAME_VERSIONS_LOAD_START',
	IFRAME_VERSIONS_LOAD_DONE = 'IFRAME_VERSIONS_LOAD_DONE',
	IFRAME_VERSIONS_LOAD_FAIL = 'IFRAME_VERSIONS_LOAD_FAIL'
}
